module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Lema_COA-86749065cd8e27b494554cbe245e81dd.svg";